import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FlexContainer,
  Headline,
  IconStatusCheckSquareColor,
  Text,
} from '@/components'
import CenteredPageTemplate from '@/components/layout/page-templates/CenteredPageTemplate'
import testLabels from './AntiPhishingSetup.labels'
import * as styles from './AntiPhishingSetup.styles'
import * as icons from './components/InstructionIcons'
import InstructionRow from './components/InstructionRow'

const AntiPhishingSetup = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const handleShowSuccess = () => {
      const instructionsView = document.getElementById(
        'safari-setup-content-instructions'
      )
      const successView = document.getElementById(
        'safari-setup-content-success'
      )
      if (instructionsView) {
        instructionsView.style.display = 'none'
      }
      if (successView) {
        successView.style.display = 'flex'
      }
    }

    document.addEventListener('sfExtensionShowSuccess', handleShowSuccess)

    return () =>
      document.removeEventListener('sfExtensionShowSuccess', handleShowSuccess)
  }, [])

  return (
    <CenteredPageTemplate size="small">
      <FlexContainer
        align="center"
        direction="column"
        flexWrap="nowrap"
        id="safari-setup-content-instructions"
      >
        <Headline
          fontWeight={500}
          testDataLabel={testLabels.antiPhishingSetupTitle}
          type="h2"
        >
          {t('SafariInstructionsTitle')}
        </Headline>
        <FlexContainer
          align="center"
          css={styles.instructionsContainer}
          direction="column"
          flexWrap="nowrap"
          testDataLabel={testLabels.antiPhishingSetupDescription}
        >
          <InstructionRow
            Icon={icons.IconSetupMenu}
            text={t('SafariInstructionsStepMenu')}
          />
          <InstructionRow
            Icon={icons.IconPlugin}
            text={t('SafariInstructionsStepManageExtension')}
          />
          <InstructionRow
            Icon={icons.IconApp}
            text={t('SafariInstructionsStepFindApp')}
          />
          <InstructionRow
            Icon={icons.IconTap}
            text={t('SafariInstructionsStepSelectApp')}
          />
          <InstructionRow
            Icon={icons.IconList}
            text={t('SafariInstructionsStepPermissionAllow')}
          />
          <InstructionRow
            Icon={icons.IconSuccess}
            text={t('SafariInstructionsStepPermissionAllowFinal')}
          />
        </FlexContainer>
      </FlexContainer>

      <FlexContainer
        align="center"
        css={styles.successContainer}
        direction="column"
        flexWrap="nowrap"
        gap={32}
        id="safari-setup-content-success"
      >
        <IconStatusCheckSquareColor size={80} />
        <FlexContainer direction="column">
          <Headline
            fontWeight={500}
            testDataLabel={testLabels.antiPhishingSetupTitleSuccess}
            type="h2"
          >
            {t('SafariSetupSuccessTitle')}
          </Headline>
          <Text testDataLabel={testLabels.antiPhishingSetupDescriptionSuccess}>
            {t('SafariSetupSuccessDescription')}
          </Text>
        </FlexContainer>
      </FlexContainer>
    </CenteredPageTemplate>
  )
}

export default AntiPhishingSetup
